<template>
    <div>
        <v-card class="pa-2" color="#42A5F5">
            <canvas id="chart5" ref="chart5" height="500"></canvas>
        </v-card>
    </div>
</template>

<script>
import Chart from 'chart.js';
import moment from 'moment';

export default {
    data() {
        return {
            chart: null,
            canvas: null,
            loading: true,
            labels: [],
            amount: []
        }
    },
    watch: {
        chartData() {
            this.render();
        }
    },
    props: {
        chartData: Array
    },
    mounted() {
        this.render();
    },
    methods: {
        render() {
            if(this.chart && this.canvas) {
                this.chart.destroy();
                this.canvas = null;
            }
            
            let moto = [];
            let rebiller = [];
            let scheduler = [];
            let payByLink = [];

            this.labels = [...new Set(this.chartData.map(item => item.date))];
            this.chartData.map(e => { if(e.source == 'MOTO') moto.push(e.amount); });
            this.chartData.map(e => { if(e.source == 'REBILLER') rebiller.push(e.amount); });
            this.chartData.map(e => { if(e.source == 'SCHEDULER') scheduler.push(e.amount); });
            this.chartData.map(e => { if(e.source == 'PAYBYLINK') payByLink.push(e.amount); });

            this.canvas = this.$refs['chart5'].getContext('2d');
            let chartData = { datasets: [] };
            chartData.datasets.push({ label: 'Moto',
                                      data: moto,
                                      borderColor: '#FFF',
                                      borderWidth: 1,
                                      backgroundColor: "rgb(121,134,203,0.5)"});
            
            chartData.datasets.push({ label: 'Rebiller',
                                      data: rebiller,
                                      borderColor: '#FFF',
                                      borderWidth: 1,
                                      backgroundColor: "rgb(245,124,0, 0.5)" });

            chartData.datasets.push({ label: 'Pay By Link',
                                      data: payByLink,
                                      borderColor: '#FFF',
                                      borderWidth: 1,
                                      backgroundColor: "rgb(229,115,115, 0.5)" });
            
            chartData.datasets.push({ label: 'Scheduler',
                                      data: scheduler,
                                      borderColor: '#FFF',
                                      borderWidth: 1,
                                      backgroundColor: "rgb(178,223,219,0.5)"});

            this.chart = new Chart(this.canvas, {
                type: 'bar',
                data: {
                    labels: this.labels,
                    datasets: chartData.datasets,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: true,
                        text: '',
                        fontSize: 12,
                        fontStyle: 400,
                        fontColor: '#FFF'
                    },
                    scales: {
                        yAxes: [{
                            stacked: true,
                            positions: 'left',
                            ticks: {
                                id: 1,
                                minTicksLimit: 10,
                                beginAtZero: true,
                                fontSize: 10,
                                fontColor: '#FFF',
                                callback: function(value) {
                                    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0 }).format(value);
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Value',
                                fontSize: 12,
                                fontColor: '#FFF'
                            },
                            gridLines: {
                                zeroLineColor: "rgb(255, 255, 255, 0.2)",
                                color: "rgb(255, 255, 255, 0.2)"
                            }
                        }],
                        xAxes: [{
                            stacked: true,
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10,
                                fontColor: '#FFF'
                            },
                            scaleLabel: {
                                display: true,
                                labelString: '',
                                fontSize: 12,
                                fontColor: '#FFF'
                            },
                            gridLines: {
                                zeroLineColor: "rgb(255, 255, 255, 0.2)",
                                color: "rgb(255, 255, 255, 0.2)"
                            }
                        }]
                    },
                    legend: {
                        display: true,
                        labels: {
                            fontSize: 10,
                            fontColor: '#FFF',
                            usePointStyle: true
                        },
                        position: 'top'
                    },
                    tooltips: {
                        mode: 'label',
                        callbacks: {
                            label: function(tooltipItem, data) { 
                                return data.datasets[tooltipItem.datasetIndex].label + ' £' + tooltipItem.yLabel;
                            }
                        }
                    }
                }
            })
        }
    }
}
</script>

<style>

</style>